// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__227Wa","fullWidth":"login_fullWidth__x1Rdu"};